module.exports = __webpack_public_path__ + "static/media/Rectangle122.28ab976b.png";